import {Action} from "@ngrx/store";

export const LOAD_HOSTING_RESOURCES: string = '[hosting block] Load Hosting Resources';
export const LOAD_HOSTING_RESOURCES_SUCCESS: string = '[hosting block] Load Hosting Resources Success';
export const LOAD_HOSTING_RESOURCES_FAIL: string = '[hosting block] Load Hosting Resources Fail';

export const LOAD_HOSTING_RESOURCES_BY_WEBSITE: string = '[hosting block by website] Load Hosting Resources by Website';
export const LOAD_HOSTING_RESOURCES_BY_WEBSITE_SUCCESS: string = '[hosting block by website] Load Hosting Resources by Website Success';
export const LOAD_HOSTING_RESOURCES_BY_WEBSITE_FAIL: string = '[hosting block by website] Load Hosting Resources by Website Fail';

export class LoadHostingResources implements Action {

  readonly type: string = LOAD_HOSTING_RESOURCES;
  constructor(public payload?: number) {}

}

export class LoadHostingResourcesSuccess implements Action {

  readonly type: string = LOAD_HOSTING_RESOURCES_SUCCESS;
  constructor(public payload: {}) {}

}

export class LoadHostingResourcesFail implements Action {

  readonly type: string = LOAD_HOSTING_RESOURCES_FAIL;
  constructor(public payload: string) {}

}


export class LoadHostingResourcesByWebsite implements Action {
  readonly type: string = LOAD_HOSTING_RESOURCES_BY_WEBSITE;
  constructor(public payload: number) {}
}

export class LoadHostingResourcesByWebsiteSuccess implements Action {

  readonly type: string = LOAD_HOSTING_RESOURCES_BY_WEBSITE_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    entities: any,
  }) {}

}

export class LoadHostingResourcesByWebsiteFail implements Action {

  readonly type: string = LOAD_HOSTING_RESOURCES_BY_WEBSITE_FAIL;
  constructor(public payload: string) {}

}

export type HostingResourcesAction = LoadHostingResources | LoadHostingResourcesSuccess | LoadHostingResourcesFail | LoadHostingResourcesByWebsite | LoadHostingResourcesByWebsiteSuccess | LoadHostingResourcesByWebsiteFail;
